<script>
    import moment from 'moment'
    import {it} from 'vuejs-datepicker/dist/locale'
    import Datepicker from 'vuejs-datepicker';
    import ReservationTimePicker from '../reservation/ReservationTimePicker.vue';
    import {ABTesting} from '../../mixins/abtesting'
    import {Gtag} from '../../mixins/ga'
    import {Form} from '../../helpers/Form/Form'

    export default {
        mixins: [ABTesting,Gtag],
        props: {
            source: String,
            data: {
                type: Object,
                default() {
                    return {}
                }
            },
        },
        components: {Datepicker, ReservationTimePicker},
        data() {
            return {
                type: 'lessons',
                available_places: null,
                payloadKey: null,
                date: '',
                form: {
                    reservation_date: '',
                    reservation_time: '',
                    course_id: null,
                    price: 0,
                    membership_fee: 0,
                    is_trial_lesson: 0,
                },
                rangeHours: [],
                defaultDays: [0, 1, 2, 3, 4, 5, 6],
                it: it,
                increment: 0,
                fetch: new Form({
                    max_partecipants: null,
                    reservation_date: null,
                    reservation_time: null,                    
                })
            }
        },
        computed: {
            emptyReservation() {
                return _.isEmpty(this.form.reservation_date) || _.isEmpty(this.form.reservation_time)
            },
            lessonDateIsPast() {
                let now = moment()

                if (!this.data) {
                    return false
                }

                if (this.type == 'lessons') {
                    let availableDayTimes = this.data.days.filter(i => {
                        return i.for_first_lesson && !i.start_at
                    })
                    let availableDateTimes = this.data.days.filter(i => {
                        return i.for_first_lesson && i.start_at
                    })

                    if (availableDayTimes.length > 0) {
                        return false
                    }

                    if (availableDateTimes.length > 0) {
                        let current = moment()
                        let start = moment(availableDateTimes[0].start_date)
                        let end = moment(_.last(availableDateTimes).end_date)

                        return current.isBefore(start) || current.isAfter(end)
                    } else {
                        if (moment(this.data.lesson_date_time).isBefore(now)) {
                            return moment(this.data.end_date).isBefore(now);
                        }

                        if (this.data.lesson_date_time) {
                            let date = moment(this.data.lesson_date_time)
                            return date.isBefore(now)
                        } else {
                            let start = moment(this.data.start_date)
                            let end = moment(this.data.end_date)

                            return now.isBefore(start) ? false : !now.isBetween(start, end)
                        }
                    }
                } else {
                    let start = moment(this.data.start_date)
                    let end = moment(this.data.end_date)

                    return now.isBefore(start) || now.isAfter(end)
                }
                return false
            },
            lessonDateIsPastOrFuture() {
                let now = moment()

                if (!this.data) {
                    return false
                }

                if (this.data.lesson_date_time) {
                    let date = moment(this.data.lesson_date_time)
                    return date.isBefore(moment()) || date.isAfter(moment())
                } else {
                    let start = moment(this.data.start_date)
                    let end = moment(this.data.end_date)

                    return !now.isBetween(start, end)
                }
                return false
            },
            disabledDates() {
                let disabledDays = [];
                let disabledDates = [];
                let now = moment()

                if (!this.data) {
                    return {}
                }

                let availableDayTimes = this.data.days.filter(i => {
                    return i.for_first_lesson && !i.start_at
                })

                let availableDateTimes = this.data.days.filter(i => {
                    return i.for_first_lesson && i.start_at
                })        

                let days = this.data.days.filter(i => {
                    return !i.for_first_lesson
                })                       
                console.log(availableDayTimes)
                console.log(availableDateTimes)
                if (this.type != 'entries') {
                    if (availableDayTimes.length > 0) {
                        let availableDays = availableDayTimes.map(lesson => lesson.dow);
                        let start = moment(this.data.start_date)
                        let end = moment(this.data.end_date)

                        return {
                            customPredictor: (date) => {
                                let current = moment(date)
                                return current.isBefore(start) || current.isAfter(end) || !availableDays.includes(current.isoWeekday() - 1)
                            }
                        }         
                    } else if (availableDateTimes.length > 0) {
                        let mappedDates = availableDateTimes.map(i => {
                            return moment(i.start_at).format('YYYY-MM-DD')
                        })

                        return {
                            customPredictor: (date) => {
                                let current = moment(date)
                                return !mappedDates.includes(current.format('YYYY-MM-DD'))
                            }
                        }                           
                    } else if (this.data.lesson_date_time && !moment(this.data.lesson_date_time).isBefore(now)) {
                        let lessonDate = moment(this.data.lesson_date_time);
                        return {
                            customPredictor: (date) => {
                                let current = moment(date)
                                return !current.isSame(lessonDate, 'day')
                            }
                        }
                    } else if (this.data.days.length > 0) {
                        let availableDays = this.data.days.map(lesson => lesson.dow);
                        let start = moment(this.data.start_date)
                        let end = moment(this.data.end_date)
                        let now = moment()
 
                        return {
                            customPredictor: (date) => {
                                let current = moment(date)
                                
                                if (
                                    current.isBefore(now, 'date') ||
                                    current.isBefore(start, 'date') || 
                                    current.isAfter(end, 'date') || 
                                    !availableDays.includes(current.isoWeekday() - 1)
                                ) {
                                    return true
                                }

                                return false
                            }
                        }     
                    }
                } else {
                    if (days.length > 0) {
                        let now = moment()
                        let availableDays = days.map(lesson => lesson.dow);
                        let start = moment(this.data.start_date)
                        let end = moment(this.data.end_date)

                        return {
                            customPredictor: (date) => {
                                let current = moment(date)

                                if (
                                    current.isBefore(now, 'date') ||
                                    current.isBefore(start, 'date') || 
                                    current.isAfter(end, 'date') || 
                                    !availableDays.includes(current.isoWeekday() - 1)
                                ) {
                                    return true
                                }

                                return false
                            }
                        }     
                    }                    
                }
            }, 
            disableButton() {
                return this.form.reservation_date.length > 0 && this.form.reservation_time.length > 0;
            },
            reservationTotal() {
                return this.form.price + this.form.membership_fee
            }
        },
        watch: {
            data(val) {
                if (val.hasOwnProperty('id')) {
                    this.$set(this.form, 'course_id', val.id)

                    this.init()
                }
            },
            date(val) {
                let formatDate = moment(new Date(val)).format('YYYY-MM-DD')

                this.$set(this.form, 'reservation_date', formatDate);
            },
            lessonDateIsPast(val) {
                this.$set(this.form, 'is_trial_lesson', val ? 1 : 0)
            },
            'form.reservation_time': {
                async handler(val) {
                    if (val) {
                        this.$set(this.fetch, 'reservation_date', this.form.reservation_date)
                        this.$set(this.fetch, 'reservation_time', val)

                        await this.fetch
                            .post(route('courses.available_places', this.form.course_id))
                            .then(response => {
                                this.$set(this, 'available_places', response.available_places)
                                this.$bus.$emit('update-available-places', response.available_places)
                            })
                            .catch(e => console.log('form.reservation_time error', e))
                    }
                }
            }
        },
        mounted() {
            $('#contactFormModal').modal({
                show: false,
                backdrop: 'static',
                keyboard: false
            });

            $("#reservationModal").on('hidden.bs.modal', () => {
                if (this.$vnode.key == this.payloadKey) {
                    this.$set(this, 'type', 'lessons')
                    this.$set(this, 'form', {
                        reservation_date: '',
                        reservation_time: '',
                        course_id: null,
                        price: 0,
                        membership_fee: 0,
                        is_trial_lesson: 0,
                    })
                }
            })

            this.$bus.$on('reservation-trial', (payload) => {
              if (payload.courseId) {
                this.$set(this.form, 'course_id', payload.courseId)
              }
              
                if (this.$vnode.key == payload.key) {
                    this.$set(this.form, 'is_trial_lesson', payload.value)
                    this.$set(this, 'type', payload.type)
                    this.$set(this, 'payloadKey', payload.key)

                    this.init()

                    $("#reservationModal").modal('show')          
                }      
            })
            this.$bus.$emit('update-reservation', {
                course: this.data,
                reservation: this.form
            })

            if (!this.form.course_id) {
                if (this.data && this.data.hasOwnProperty('id')) {
                    this.$set(this.form, 'course_id', this.data.id)

                    this.init()
                }           
            }
        },
        methods: {
            init() {
                if (this.data) {
                    if (this.type != 'entries') {
                        this.$set(this.form, 'is_trial_lesson', 1)

                        if (this.data.trial_with_membership_fee) {
                            if (this.data.fee) {
                                this.$set(this.form, 'membership_fee', parseFloat(this.data.fee.price))
                            } else if (this.data.membership_fee) {
                                this.$set(this.form, 'membership_fee', this.data.membership_fee)
                            }
                        }
                        
                        if (this.data.lesson_price > 0) {
                            this.$set(this.form, 'price', parseFloat(this.data.lesson_price))
                        }

                        this.setDefaultLessonDateTime(this.data.days);
                    } else {
                        let days = this.data.days.filter(i => !i.for_first_lesson)
                        this.$set(this.form, 'membership_fee', 0)

                        this.setDefaultLessonDateTime(days);
                    }
                }
            },
            onDismissReservationModal() {
                $("#reservationModal").modal('hide')
            },
            setDefaultLessonDateTime(days) {
                let now = moment()

                this.$set(this, 'rangeHours', [])

                if (this.type == 'lessons') {
                    let availableDayTimes = days.filter(i => {
                        return i.for_first_lesson && !i.start_at
                    })

                    let availableDateTimes = days.filter(i => {
                        return i.for_first_lesson && i.start_at
                    })      

                    if (availableDayTimes.length > 0) {
                        let days = _.uniqBy(availableDayTimes, 'day')  
                        let firstDay = _.head(days)
                        let selectedDate = now
                        let step = 1
                        let continueCicle = true

                        if ((parseInt(selectedDate.format('d')) - 1) == firstDay.dow) {
                            this.$set(this, 'date', selectedDate.format('YYYY-MM-DD'))
                            this.$set(this.fetch, 'max_partecipants', firstDay.max_partecipants)
                        } else {
                            while (continueCicle) {
                                selectedDate = selectedDate.add(step, 'days')

                                if ((parseInt(selectedDate.format('d')) - 1) == firstDay.dow) {
                                    continueCicle = false
                                }
                            }

                            this.$set(this, 'date', selectedDate.format('YYYY-MM-DD'))
                            this.$set(this.fetch, 'max_partecipants', firstDay.max_partecipants)
                        }         

                        var times = availableDayTimes.filter(i => i.dow == (parseInt(selectedDate.isoWeekday()) - 1))
                        for (let i = 0; i < times.length; i++) {
                            if (times[i].slots.length > 0) {
                                for (let slot in times[i].slots) {
                                    this.rangeHours.push(times[i].slots[slot])
                                }
                            } else {                            
                                if (times[i].interval > 0) {
                                    this.setIntervalTimes(times[i])
                                } else {
                                    this.rangeHours.push(times[i])
                                }
                            }
                        }                                 
                    } else if (availableDateTimes.length) {
                        let firstAvailable = availableDateTimes[0]
                        let lessonDate = moment(`${firstAvailable.start_at} ${firstAvailable.start_time}`, 'YYYY-MM-DD HH:mm:ss')
                        let start_time = lessonDate.format('HH:mm')
                        let end_time = moment(`${firstAvailable.start_at} ${firstAvailable.end_time}`, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')

                        this.$set(this, 'date', firstAvailable.start_at)     
                        this.$set(this.fetch, 'max_partecipants', firstAvailable.max_partecipants)

                        if (firstAvailable.slots.length > 0) {
                            for (let slot in firstAvailable.slots) {
                                this.rangeHours.push(firstAvailable.slots[slot])
                            }
                        } else {                                
                            if (firstAvailable.interval > 0) {
                                this.setIntervalTimes(firstAvailable)
                            } else {
                                this.rangeHours.push(firstAvailable)
                            }
                        }
                    } else if (!this.data.lesson_date_time) {
                        let firstAvailable = null
                        let start = moment(this.data.start_date)
                        if (now.isBefore(start)) {
                            firstAvailable = start.clone().add(this.increment, 'days');
                        } else {
                            firstAvailable = moment(new Date()).add(this.increment, 'days');
                        }

                        let firstFormetted = firstAvailable.format('YYYY-MM-DD');
                        let firstChar = firstAvailable.format('dddd');
                        let first = firstChar.charAt(0).toUpperCase() + firstChar.slice(1);
                        let availableDays = days.filter(i => !i.for_first_lesson).map(lesson => lesson.day);

                        if (availableDays.indexOf(first) !== -1) {              
                            //se tra le date disponibili c'è domani mi metti la data
                            this.date = new Date(firstFormetted);
                            this.onDateSelected(firstAvailable);
                            let day = _.head(days.filter(i => i.dow == firstAvailable.isoWeekday() - 1))
                            if (day && day.hasOwnProperty('max_partecipants')) {
                                this.$set(this.fetch, 'max_partecipants', day.max_partecipants)
                            }
                            this.increment = 1;
                        } else {
                            //altrimenti controlli dopodomani e così via
                            this.increment += 1;
                            this.setDefaultLessonDateTime(this.data.days)
                        }
                    } else {
                        let lessonDate = moment(this.data.lesson_date_time)

                        if (!moment(this.data.lesson_date_time).isBefore(now)) {
                            this.$set(this, 'date', this.data.lesson_date_time)
                        } else {
                            let days = _.uniqBy(this.data.days, 'day')  
                            let firstDay = _.head(days)
                            let selectedDate = now
                            let step = 1
                            let continueCicle = true

                            if (parseInt(selectedDate.isoWeekday()) - 1 == firstDay.dow) {
                                this.$set(this, 'date', selectedDate.format('YYYY-MM-DD'))
                                this.$set(this.fetch, 'max_partecipants', firstDay.max_partecipants)
                            } else {
                                while (continueCicle) {
                                    selectedDate = selectedDate.add(step, 'days')

                                    if (parseInt(selectedDate.isoWeekday()) - 1 == firstDay.dow) {
                                        continueCicle = false
                                    }
                                }

                                this.$set(this, 'date', selectedDate.format('YYYY-MM-DD'))
                                this.$set(this.fetch, 'max_partecipants', firstDay.max_partecipants)
                            }

                            var times = this.data.days.filter(i => i.dow == (parseInt(selectedDate.isoWeekday()) - 1))
                            for (let i = 0; i < times.length; i++) {
                                if (times[i].slots.length > 0) {
                                    for (let slot in times[i].slots) {
                                        this.rangeHours.push(times[i].slots[slot])
                                    }
                                } else {                                
                                    if (times[i].interval > 0) {
                                        this.setIntervalTimes(times[i])
                                    } else {
                                        this.rangeHours.push(times[i])
                                    }
                                }
                            }
                        }
                    }
                } else {
                    let firstAvailable = null
                    let start = moment(this.data.start_date)

                    if (now.isBefore(start)) {
                        firstAvailable = start.clone().add(this.increment, 'days');
                    } else {
                        firstAvailable = moment(new Date()).add(this.increment, 'days');
                    }                    
                    let firstFormetted = firstAvailable.format('YYYY-MM-DD');
                    let firstChar = firstAvailable.format('dddd');
                    let first = firstChar.charAt(0).toUpperCase() + firstChar.slice(1);
                    let availableDays = days.map(lesson => lesson.day);

                    if (availableDays.indexOf(first) !== -1) {
                        //se tra le date disponibili c'è domani mi metti la data
                        this.date = new Date(firstFormetted);
                        this.onDateSelected(firstAvailable);
                        let day = _.head(days.filter(i => i.dow == (firstAvailable.isoWeekday() - 1)))
                        this.$set(this.fetch, 'max_partecipants', day.max_partecipants)
                        this.increment = 1;

                        if (day.slots.length > 0) {
                            for (let slot in day.slots) {
                                this.rangeHours.push(day.slots[slot])
                            }
                        } else {                                
                            if (day.interval > 0) {
                                this.setIntervalTimes(day)
                            } else {
                                this.rangeHours.push(day)
                            }
                        }                        
                    } else {
                        let days = this.data.days.filter(i => !i.for_first_lesson)
                        //altrimenti controlli dopodomani e così via
                        this.increment += 1;
                        this.setDefaultLessonDateTime(days)
                    }                    
                }

                this.$set(this, 'rangeHours', _.uniqBy(this.rangeHours, 'start_time'))
            },
            allDayWeeks(dayWeek) {
                let dayWeeks = []
                let month = ''
                let startDayWeek = dayWeek.add(7, 'days');

                month = dayWeek.month();
                while (month === startDayWeek.month()) {
                    dayWeeks.push(new Date(
                        startDayWeek.format('YYYY'),
                        startDayWeek.format('MM') - 1,
                        startDayWeek.format('DD')
                    ))
                    startDayWeek = startDayWeek.add(7, 'days');
                }
                return dayWeeks
            },
            onDateSelected(e) {
                let now = moment()        
                let selectedDay = parseInt(moment(e).isoWeekday()) - 1;

                if (selectedDay < 0)
                    selectedDay = 6;

                var times = this.data.days.filter(i => i.dow == selectedDay && !i.parent_id)
                this.$set(this.form, 'reservation_time', '')
                this.$set(this.fetch, 'max_partecipants', null)
                this.$set(this, 'rangeHours', [])

                let availableDayTimes = this.data.days.filter(i => {
                    return i.for_first_lesson && !i.start_at && !i.parent_id
                })  
                let availableDateTimes = this.data.days.filter(i => {
                    return i.for_first_lesson && i.start_at && !i.parent_id
                })   

                if (this.type == 'lessons') {
                    if (availableDayTimes.length > 0) {
                        times = availableDayTimes.filter(i => i.dow == selectedDay)
                        for (let i = 0; i < times.length; i++) {
                            if (times[i].slots.length > 0) {
                                for (let slot in times[i].slots) {
                                    this.rangeHours.push(times[i].slots[slot])
                                }
                            } else {                        
                                this.rangeHours.push(times[i])
                            }
                        }
                    } else if (availableDateTimes.length > 0) {
                        times = availableDateTimes.filter(i => i.dow == selectedDay)
                        for (let i = 0; i < times.length; i++) {
                            if (times[i].slots.length > 0) {
                                for (let slot in times[i].slots) {
                                    this.rangeHours.push(times[i].slots[slot])
                                }
                            } else {                        
                                this.rangeHours.push(times[i])
                            }
                        }
                    } else if (this.data.lesson_date_time && !moment(this.data.lesson_date_time).isBefore(now)) {
                        let lessonDate = moment(this.data.lesson_date_time)
                        let interval = this.data.days[0].interval
                        this.rangeHours.push({
                            start_time: lessonDate.format('HH:mm')
                        })
                    } else {
                        for (let i = 0; i < times.length; i++) {
                            if (times[i].slots.length > 0) {
                                for (let slot in times[i].slots) {
                                    this.rangeHours.push(times[i].slots[slot])
                                }
                            } else {
                                if (times[i].interval > 0) {
                                    this.setIntervalTimes(times[i])
                                } else {
                                    this.rangeHours.push(times[i])
                                }
                            }
                        }
                    }
                } else {
                    var times = this.data.days.filter(i => {
                        return  i.dow == selectedDay && 
                            !i.for_first_lesson && 
                            !i.parent_id
                    })
                    for (let i = 0; i < times.length; i++) {
                        if (times[i].slots.length > 0) {
                            for (let slot in times[i].slots) {
                                this.rangeHours.push(times[i].slots[slot])
                            }
                        } else {
                            if (times[i].interval > 0) {
                                this.setIntervalTimes(times[i])
                            } else {
                                this.rangeHours.push(times[i])
                            }
                        }
                    }                    
                }
            },
            setIntervalTimes(times) {
                let interval = times.interval
                let startTime = new moment(times.start_time, 'HH:mm:ss');
                let endTime = new moment(times.end_time, 'HH:mm:ss')
                let duration = endTime.diff(startTime, 'minutes')
                let maxInterval = duration / interval;

                for (let i = 0; i <= maxInterval; i++) {
                    this.rangeHours.push({
                        start_time: startTime.format('HH:mm'),
                        end_time: startTime.add(interval, 'minute').format('HH:mm')
                    })
                    startTime = startTime
                    if (!startTime.diff(new moment(times.end_time, 'HH:mm:ss'))) {
                        break;
                    }
                }

            },
            onSubmit() {
                if (!this.disableButton) {
                    if (!this.form.reservation_date) {
                        this.$refs.inline.$children[0].$emit('showCalendar')
                    } else if (!this.form.reservation_time) {
                        this.$bus.$emit('open-time-picker')
                    }
                } else {
                    let label = '#button-prenota-ingresso'
                    if (this.version == 'b') {
                        label = '#button-prenota-ingresso-senza'
                    }

                    this.sendReservationFormGaEvent(this.form)               

                    let query = Object.keys(this.form)
                        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(this.form[k]))
                        .join('&');

                    location.href = `${this.source}?${query}`
                }
            },
            onSubmitTrial() {
                this.sendGaEvent(
                    'Prenotazionestart',
                    'Corsi', 
                    '#prenota-prova-step0'
                )
                
                this.$set(this.form, 'is_trial_lesson', 1)

                this.onSubmit()
            },
            onReset() {
                if (this.getVersion() == 'a') {
                    this.setDefaultLessonDateTime(this.data.days);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/reservation/ReservationForm.vue